import { ResourceType } from "@enums/ResourceType";
import { SortType } from "@enums/SortType";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "../veriTable/veriTable.component";
import { ExternalReferenceService } from "./externalReference.service";
import { IExternalReference, IExternalReferenceType } from "./externalReferences.interfaces";
import "./externalReferences.scss";

export class ExternalReferenceComponentController implements angular.IComponentController {
    loading: boolean = false;
    tableHeaders: IVeriTableHeader[] = [];
    tableRows: IVeriTableRow<IExternalReference>[] = [];
    selectedRecord: IExternalReference;

    driverId: number;
    geofenceId: number;
    vehicleId: number;

    disableAdd: boolean;

    reloadParent: () => void;

    static $inject = ["$mdDialog", "externalReferenceService", "translationService"];

    constructor(
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly externalReferenceService: ExternalReferenceService,
        private readonly translationService: TranslationService    ) {
    }

    $onInit() {
        this.loadData(true);
        this.createHeaders();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.loadData(true);

        if (this.getId() < 0) {
            this.disableAdd = true;
        }
    }

    getId(): number {
        return this.driverId || this.vehicleId || this.geofenceId;
    }

    getType(): ResourceType {
        if (this.driverId) {
            return ResourceType.Driver;
        }
        else if (this.vehicleId) {
            return ResourceType.Vehicle;
        }
        else {
            return ResourceType.Geofence;
        }
    }

    onRowClicked($event: MouseEvent, row: IVeriTableRow<IExternalReference>) {
        var externalReference: IExternalReference = {
            DriverId: row.data.DriverId,
            VehicleId: row.data.VehicleId,
            GeofenceId: row.data.GeofenceId,
            Id: row.data.Id,
            ExternalReference: row.data.ExternalReference,
            ExternalReferenceTypeId: row.data.ExternalReferenceTypeId
        };

        this.openExternalReferenceRecordTaskDialog($event, externalReference);
    }

    openExternalReferenceRecordTaskDialog($event: MouseEvent, externalReference: IExternalReference) {

        const controller = ($mdDialog) => {
            return {
                hide: (record: IExternalReference) => { $mdDialog.hide(record); },
                externalReference: externalReference
            }
        };

        controller.$inject = ["$mdDialog"];

        const dialogOptions: angular.material.IDialogOptions = {
            targetEvent: $event,
            escapeToClose: true,
            clickOutsideToClose: true,
            template: require("./externalReferenceDialog/externalReferenceRecord.dialog.html"), // Use scope
            controller: controller,
            controllerAs: "$ctrl"
        };

        return this.$mdDialog
            .show(dialogOptions)
            .then(() => {
                this.loadData(true,true)
                    .then(() => {
                        this.reloadParent();
                    });
            });
    }

    loadData(loading = true, invalidateCache = false): angular.IPromise<any> {
        this.loading = loading;

        return this.externalReferenceService.getExternalTypes(invalidateCache)
            .then(externalTypes => {
                this.externalReferenceService.getExtReferenceData(externalTypes, this.getId(), this.getType(), invalidateCache)
                    .then((externalReferences) => {
                        if (invalidateCache) {
                            this.externalReferenceService.updateCachedValues(externalReferences, externalTypes);
                        }

                        this.tableRows = [];

                        externalReferences.forEach(externalReference => {

                            externalReference.externalReferenceType = externalTypes.firstOrDefault<IExternalReferenceType>( type =>type.Id == externalReference.ExternalReferenceTypeId);

                            var tableRow: IVeriTableRow<IExternalReference> = {
                                data: externalReference,
                                cells: this.createTableCells(externalReference)
                            };

                            this.tableRows.push(tableRow);
                        });

                        this.loading = false;
                    })
                    .catch((err) => {
                        console.log("Error retrieving external reference data: ", err);
                        throw (err);
                    });
            });
    }

    addExternalReference($event: MouseEvent) {
        this.selectedRecord = {
            GeofenceId: this.geofenceId,
            DriverId: this.driverId,
            VehicleId: this.vehicleId,
            Id: 0,
            ExternalReference: "",
            ExternalReferenceTypeId: 0
        };

        this.openExternalReferenceRecordTaskDialog($event, this.selectedRecord);
    }

    // ----------------------------------

    private createHeaders() {
        this.tableHeaders = [
            {
                title: this.translationService.t("externalReference.externalId"),
                sortable: true,
                sortType: SortType.String
            },
            {
                title: this.translationService.t("externalReference.type"),
                sortable: true,
                sortType: SortType.String
            }];
    }

    private createTableCells(result: IExternalReference): IVeriTableRowCell[] {
        const cells: IVeriTableRowCell[] = [
            { contents: result.ExternalReference, sortData: result.ExternalReference, sanitize: true },
            { contents: result.externalReferenceType.Type, sortData: result.externalReferenceType.Type, sanitize: true }
        ];

        return cells;
    }
}

export class ExternalReferenceComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: any;

    constructor() {
        this.bindings = {
            driverId: "<?",
            geofenceId: "<?",
            vehicleId: "<?",
            reloadParent: "&"
        };

        this.controller = ExternalReferenceComponentController;
        this.template = require("./externalReference.maintenance.html");
    }
}
